/**
 * mentions.js — Etiquetar compañeros con "@" en cualquier campo contenteditable
 * (compositor de publicaciones y de comentarios). Inserta un chip no editable
 * <span class="mention" data-uid="ID">@Nombre</span>.
 */
const Mentions = (() => {
  let _dd = null;          // dropdown
  let _el = null;          // editor activo
  let _range = null;       // rango del token "@..."
  let _items = [];
  let _sel = -1;

  function _ensureDropdown() {
    if (_dd) return _dd;
    _dd = document.createElement('div');
    _dd.className = 'mention-dropdown';
    _dd.style.display = 'none';
    document.body.appendChild(_dd);
    return _dd;
  }

  function _hide() {
    if (_dd) _dd.style.display = 'none';
    _items = []; _sel = -1; _range = null;
  }

  // Detecta si el cursor está escribiendo un token "@palabra"
  function _context() {
    const s = window.getSelection();
    if (!s || !s.rangeCount) return null;
    const r = s.getRangeAt(0);
    if (!r.collapsed || r.startContainer.nodeType !== 3) return null;
    const node = r.startContainer;
    const before = node.textContent.slice(0, r.startOffset);
    const m = /(?:^|\s)@([\wÀ-ÿ.]*)$/.exec(before);
    if (!m) return null;
    const start = r.startOffset - m[1].length - 1;   // posición del '@'
    const rng = document.createRange();
    rng.setStart(node, start);
    rng.setEnd(node, r.startOffset);
    return { query: m[1], range: rng };
  }

  async function _onInput(e) {
    _el = e.target;
    const ctx = _context();
    if (!ctx) { _hide(); return; }
    _range = ctx.range;
    if (ctx.query.length < 1) { _hide(); return; }
    try {
      const resp = await API.get('/users/directory', { search: ctx.query, limit: 6 });
      _items = resp?.items || [];
      _sel = _items.length ? 0 : -1;
      _render(ctx.range);
    } catch { _hide(); }
  }

  function _render(range) {
    const dd = _ensureDropdown();
    if (!_items.length) { _hide(); return; }
    dd.innerHTML = _items.map((u, i) => {
      const [bg, fg] = Utils.avatarColor(u.full_name);
      return `<div class="mention-item ${i === _sel ? 'active' : ''}" data-i="${i}">
        <span class="mention-av" style="background:${bg};color:${fg}">${Utils.avatarInitials(u.full_name)}</span>
        <span class="mention-name">${Utils.escapeHtml(u.full_name)}</span>
        <span class="mention-pos">${Utils.escapeHtml(u.position || '')}</span>
      </div>`;
    }).join('');
    // posicionar bajo el cursor
    const rect = range.getBoundingClientRect();
    dd.style.display = 'block';
    dd.style.left = Math.min(rect.left, window.innerWidth - 280) + 'px';
    dd.style.top = (rect.bottom + 4) + 'px';
    dd.querySelectorAll('.mention-item').forEach(it => {
      it.addEventListener('mousedown', ev => { ev.preventDefault(); _pick(parseInt(it.dataset.i)); });
    });
  }

  function _pick(i) {
    const u = _items[i];
    if (!u || !_range) { _hide(); return; }
    _range.deleteContents();
    const chip = document.createElement('span');
    chip.className = 'mention';
    chip.setAttribute('data-uid', u.id);
    chip.setAttribute('contenteditable', 'false');
    chip.textContent = '@' + u.full_name;
    _range.insertNode(chip);
    const space = document.createTextNode(' ');
    chip.after(space);
    const r2 = document.createRange();
    r2.setStartAfter(space); r2.collapse(true);
    const s = window.getSelection(); s.removeAllRanges(); s.addRange(r2);
    _hide();
    _el?.dispatchEvent(new Event('input', { bubbles: true }));
  }

  // Navegación con teclado (captura para tener prioridad sobre Enter=enviar)
  function _onKey(e) {
    if (!_dd || _dd.style.display === 'none' || !_items.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); e.stopPropagation(); _sel = (_sel + 1) % _items.length; _paint(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopPropagation(); _sel = (_sel - 1 + _items.length) % _items.length; _paint(); }
    else if (e.key === 'Enter' || e.key === 'Tab') { e.preventDefault(); e.stopPropagation(); _pick(_sel < 0 ? 0 : _sel); }
    else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); _hide(); }
  }
  function _paint() {
    if (!_dd) return;
    _dd.querySelectorAll('.mention-item').forEach((it, i) => it.classList.toggle('active', i === _sel));
  }

  /** Habilita menciones en un elemento contenteditable. */
  function enable(el) {
    if (!el || el._mentionsOn) return;
    el._mentionsOn = true;
    el.addEventListener('input', _onInput);
    el.addEventListener('keydown', _onKey, true);  // captura
    el.addEventListener('blur', () => setTimeout(_hide, 150));
  }

  return { enable };
})();
window.Mentions = Mentions;
